import { generatePath, NavigateFunction } from 'react-router';
import { TOrderCheckoutItemProductType } from 'api/orders/orders.types';
import { APP_ROUTES } from 'constants/routes';

export function getOrderLineItemProductHref(
  productType: TOrderCheckoutItemProductType,
  productId: string
): string | null {
  switch (productType) {
    case TOrderCheckoutItemProductType.PhoneCase:
      return generatePath(APP_ROUTES.PHONE_CASE_PRODUCT, { productId });
    default:
      return null;
  }
}

export function navigateToOrderLineProduct(
  navigate: NavigateFunction,
  productType: TOrderCheckoutItemProductType,
  productId: string
): void {
  const path = getOrderLineItemProductHref(productType, productId);
  if (path) {
    navigate(path);
  }
}

export function formatOrderPaymentJson(
  payment: Record<string, unknown> | null
): string {
  if (!payment) {
    return '';
  }
  try {
    return JSON.stringify(payment, null, 2);
  } catch {
    return String(payment);
  }
}
